export const handleIconVisibility = (visible) => {
  const iconElement = document.querySelector('.cce-widget__bubble')
  if (!iconElement) return

  iconElement.classList.toggle('cce-widget__bubble--visible', visible)
}
